import React from "react";

interface StatusToggleProps {
  active: boolean;
  onToggle: () => void;
}

export function StatusToggle({ active, onToggle }: StatusToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`
        flex items-center gap-3
        p-[8px]
        border border-[#B6BA3A]
        bg-[#FCFDF8]
        rounded
        transition-colors duration-150
        hover:bg-gray-50
        focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-[#B6BA3A]
      `}
    >
      <div
        className={`
          relative
          w-[44px] h-[18px]
          rounded-full
          transition-colors duration-150
          ${active ? "bg-[#B6BA3A]/50" : "bg-gray-300"}
        `}
      >
        <span
          className={`
            absolute
            top-1/2
            transform -translate-y-1/2
            w-[14px] h-[14px]
            bg-white key={sub.id}
            rounded-full
            shadow-sm
            transition-left duration-150
            ${active ? "left-[30px]" : "left-0"}
          `}
        />
      </div>
      <span className="font-semibold text-sm text-[#404040]">
        {active ? "Ativo" : "Inativo"}
      </span>
    </button>
  );
}
